import { make } from 'vuex-pathify';
import { ForeclosureService } from '../services/foreclosure-status.service.js';

const service = new ForeclosureService();

const state = {
  foreclosureStatuses: []
};

const mutations = make.mutations(state);

const actions = {
  async fetchForeclosureStatuses({ commit }, payload) {
    try {
      const { data } = await service.fetchForeclosureStatuses();
      commit('SET_FORECLOSURE_STATUSES', data);
      return data;
    } catch (error) {
      Logger.error('Getting Foreclosure Statuses');
      throw error;
    }
  },

  // async createForeclosureStatus(_, payload) {
  //   try {
  //     const { message, statusId } = await service.createForeclosureStatuses(payload);
  //     return { message, statusId };
  //   } catch (error) {
  //     Logger.error('Creating Foreclosure Statuse');
  //     throw error;
  //   }
  // },

  async updateForeclosureStatus(_, payload) {
    try {
      const { message } = await service.updateForeclosureStatuses(payload.id, payload);
      return { message };
    } catch (error) {
      Logger.error('Updating Foreclosure Statuses');
      throw error;
    }
  },

  // async removeForeclosureStatus(_, id) {
  //   try {
  //     const { message } = await service.removeForeclosureStatus(id);
  //     return { message };
  //   } catch (error) {
  //     Logger.error('Removing Foreclosure Statuses');
  //     throw error;
  //   }
  // }
};

export default {
  state,
  mutations,
  actions
};